@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

$link-modal-width: 356;
$link-modal-height: 354;
$link-modal-suggestion-prompt-height: 160px;

@value linkModalWidth #{$link-modal-width};
@value linkModalHeight #{$link-modal-height};

.modalWrapper {
  @include shadow-3;
  background-color: $white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  max-height: #{$link-modal-height}px;
  width: #{$link-modal-width}px;
  padding: 4px;

  @include for-phone-only {
    width: 100vw;
    // reducing the $mobile-editor-toolbar-height, to consider multiple headers, mobile toolbar footer and virtual keyboard height.
    max-height: calc(100vh - $mobile-editor-toolbar-height - env(keyboard-inset-height) - 1px);
    border-radius: 0;

    @supports (-webkit-touch-callout: none) {
      max-height: calc(100vh - 2 * $mobile-editor-toolbar-height - ($layers-tabs-height / 2));
    }
  }
}

.mobileLinkModal {
  position: fixed;
  top: 46px;
}

.modalBody {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  flex-grow: 1;
  margin: 4px 4px 0;
}

.modalBody label {
  @include sm-regular;
  color: var(--neutral-40);
  margin-bottom: 4px;
}

.input {
  @include md-regular;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 10px;
  gap: 4px;
  height: 38px;
  border-radius: 6px;
  width: 100%;
  caret-color: var(--selected-stroke);
  background: var(--light-100);
  box-shadow: 1px 1px 0 0 var(--light-90) inset, 0 2px 12px 0 var(--dark-4);
  @include blur(35px);
}

.input:focus-within {
  box-shadow: inset 0 0 0 2px var(--selected-stroke);
}

.mentionPrompt {
  max-height: $link-modal-suggestion-prompt-height;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  @include for-phone-only {
    max-height: calc($link-modal-suggestion-prompt-height - 30px);
    overflow-y: scroll;
  }
}

.mentionPromptError {
  height: 123px;
}

.mentionPromptContainer {
  background: $white;
  color: $gray-50;
}

.modalFooter {
  padding: 6px 0 0;
  margin: 2px 4px 4px 4px;
  display: flex;
  justify-content: space-between;
}

.modalButton {
  padding: 2px 8px;
}

.noHeadings {
  @include sm-regular;
  padding: 8px 8px 4px;
  color: var(--neutral-40);
  margin-bottom: 4px;
}

.modalBackButtonWrapper,
.mobileHeaderWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  gap: 12px;
}

.mobileHeaderWrapper {
  justify-content: space-between;
  padding: 8px 16px;
  button.noMargin {
    padding: 8px;
  }
}

.mobileHeaderText {
  @include lg-semibold;
}

.modalStep2Body {
  overflow: auto;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.textInput {
  margin-bottom: 8px;

  &::placeholder {
    color: $gray-40;
  }
}

button.noMargin svg {
  margin-right: 0;
}

.headingRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 8px;
  gap: 6px;
  border-radius: 6px;
  cursor: pointer;

  transition: background-color 0.2s ease-in-out;
  -webkit-transition: background-color 0.2s ease-in-out;
}

.headingRow:hover {
  background-color: var(--neutral-05);
}

.headingIcon {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 0;
  color: var(--neutral-40);
}

.headingTitle {
  @include md-regular;
  color: var(--neutral-90);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 310px;
}
